import List from './List';
import Edit from './Edit';
import Show from './Show';
export { Edit, Show, List }
export default { Edit, Show, List }
